
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 120 60"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0v15h70v15H60zm0 30v10h30V0h30z"}})]),_c('path',{attrs:{"fill":"#002868","d":"M0 0h120v60H0z"}}),_c('g',{attrs:{"stroke":"#cf142b","stroke-width":"6"}},[_c('path',{attrs:{"d":"M0 0l60 30m0-30L0 30","stroke":"#fff"}}),_c('path',{attrs:{"d":"M0 0l60 30m0-30L0 30","clip-path":"url(#a)","stroke-width":"4"}}),_c('path',{attrs:{"d":"M30 0v40M0 15h70","stroke":"#fff","stroke-width":"10"}}),_c('path',{attrs:{"d":"M30 0v40M0 15h70"}})]),_c('path',{attrs:{"d":"M60 0h60v60H0V30h60z","fill":"#fcd116"}}),_c('g',{attrs:{"transform":"translate(30 15)"}},[_c('g',{attrs:{"transform":"scale(5.1039)"}},[_c('circle',{attrs:{"r":"1","fill":"#002868"}}),_c('path',{attrs:{"id":"b","d":"M0-513674l301930 929245-790463-574305h977066l-790463 574305","fill":"#fcd116","transform":"scale(0)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"matrix(3 0 0 3 -17.5 .29)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"matrix(3 0 0 3 17.5 .29)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"matrix(3 0 0 3 0 10.29)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"matrix(3 0 0 3 0 -9.71)"}})])])
          )
        }
      }
    